// Context menu constants.
/** @constant MEASURE_ACTIVATED */
export const MEASURE_ACTIVATED = 'MEASURE_ACTIVATED';
/** @constant SELECTED_TEXT_AREA */
export const SELECTED_TEXT_AREA = 'SELECTED_TEXT_AREA';
/** @constant SELECTED_TEXT_LINE */
export const SELECTED_TEXT_LINE = 'SELECTED_TEXT_LINE';
/** @constant SELECTED_BULLDOZER */
export const SELECTED_BULLDOZER = 'SELECTED_BULLDOZER';
/** @constant SELECTED_AREA */
export const SELECTED_AREA = 'SELECTED_AREA';
/** @constant SELECTED_VOLUME */
export const SELECTED_VOLUME = 'SELECTED_VOLUME';
/** @constant SELECTED_SECTION_VOLUME */
export const SELECTED_SECTION_VOLUME = 'SELECTED_SECTION_VOLUME';
/** @constant MODEL_ACTIVATED */
export const MODEL_ACTIVATED = 'MODEL_ACTIVATED';
/** @constant CATALOGUE_ACTIVATED */
export const CATALOGUE_ACTIVATED = 'CATALOGUE_ACTIVATED';
/** @constant BIM_CATALOGUE_ACTIVATED */
export const BIM_CATALOGUE_ACTIVATED = 'BIM_CATALOGUE_ACTIVATED';
/** @constant TOGGLE_OPEN */
export const TOGGLE_OPEN = 'TOGGLE_OPEN';
/** @constant CLASSIFICATION_OPEN */
export const CLASSIFICATION_OPEN = 'CLASSIFICATION_OPEN';
/** @constant CREATED_ANNOTATION */
export const CREATED_ANNOTATION = 'CREATED_ANNOTATION';
/** @constant SELECTED_ANNOTATION */
export const SELECTED_ANNOTATION = 'SELECTED_ANNOTATION';
/** @constant PALETTE_CONTROL_ACTIVATED */
export const PALETTE_CONTROL_ACTIVATED = 'PALETTE_CONTROL_ACTIVATED';
/** @constant EYE_DROPPER_ACTIVATED */
export const EYE_DROPPER_ACTIVATED = 'EYE_DROPPER_ACTIVATED';
/** @constant TIME_CONTROLS_ACTIVATED */
export const TIME_CONTROLS_ACTIVATED = 'TIME_CONTROLS_ACTIVATED';
/** @constant VERSIONS_ACTIVATED */
export const VERSIONS_ACTIVATED = 'VERSIONS_ACTIVATED';
/** @constant TEXTURE_LABEL_EYE_DROPPER_ACTIVATED */
export const TEXTURE_LABEL_EYE_DROPPER_ACTIVATED = 'TEXTURE_LABEL_EYE_DROPPER_ACTIVATED';
/** @constant TEXTURE_LABEL_RECTANGLE_ACTIVATED */
//export const TEXTURE_LABEL_RECTANGLE_ACTIVATED = 'TEXTURE_LABEL_RECTANGLE_ACTIVATED';
/** @constant DISTRIBUTE_ACTIVATED */
export const DISTRIBUTE_ACTIVATED = 'DISTRIBUTE_ACTIVATED';
/** @constant RESOLUTION_ACTIVATED */
export const RESOLUTION_ACTIVATED = 'RESOLUTION_ACTIVATED';
/** @constant SPECIFY_TRANSFORM_ACTIVATED */
export const SPECIFY_TRANSFORM_ACTIVATED = 'SPECIFY_TRANSFORM_ACTIVATED';
/** @constant MASK_CLASSES_ACTIVATED */
export const MASK_CLASSES_ACTIVATED = 'MASK_CLASSES_ACTIVATED';

// Menu name constants.
/** @constant LOWER_CONTEXT_MENU */
export const LOWER_CONTEXT_MENU = 'LOWER_CONTEXT_MENU';

// State constants
/** @constant STATE_CHANGED */
export const STATE_CHANGED = 'STATE_CHANGED';
